import gql from "graphql-tag";

export default gql`
    mutation thirdPartySettingSet($third_party_list: [thirdPartyArgs]) {
        thirdPartySettingSet(third_party_list: $third_party_list) {
            succeed
        }
    }
`;
